import { Component, OnInit, ViewChild } from '@angular/core';
import { ViewScheduledInterviewService } from '@app/services/viewScheduledInterview.service';
import { QueryOptions } from '@app/model/query-options';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { InterviewDetails } from '@app/model/InterviewDetails';
import { FeedbackPopupComponent } from '../feedback-popup/feedback-popup.component';
import { HandleDataService } from '@app/services/handleData.service';
import { CancelInterviewComponent } from '../cancel-interview/cancel-interview.component';
import { JobService } from '@app/services/job.service';
import {  Messages } from '@app/constants/constant';
import { ApplicantService } from '@app/services/applicant.service';
import { InterviewStepStatusService } from '@app/services/interviewstep-status.service';
import { DatePipe } from '@angular/common';
import { MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { NgForm } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { JobDataService } from '@app/services/job-data.service';
import { ApplicantDataService } from '@app/services/applicantData.service';
import { Dropdown } from 'primeng';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-viewInterview',
  templateUrl: './viewInterview.component.html',
  styleUrls: ['./viewInterview.component.css']
})
export class ViewScheduledInterviewComponent implements OnInit {

  items: MenuItem[];
  isOffer: boolean;
  isJoining: boolean;
  joiningStatusOptions: any;
  dialogHeader: String;
  validSLA: boolean = true;

  @ViewChild('assignRecruiterForm', { static: false }) public assignRecruiterForm: NgForm;
  startDate: any = new Date();
  startDate1:any = new Date();
  startDate2:any = new Date();
  comment: String;
  value:String;

  viewAllFeedback(severity: string) {
    this._router.navigateByUrl("/feedback/"+severity);
    // this.messageService.add({ severity: severity, summary: 'Success', detail: 'Data Saved' });
  }

  action(rowData) {
    this.interviewData = rowData;
    this.interviewId = rowData.id;
    if(rowData.interviewStatusId == this.interviewStatusIds.offered){
      this.dialogHeader = 'Fill Joining Details'
      this.isOffer = false;
      this.isJoining = true;
      this.display = true;
      return
    }
    this.reirectToScheduleInterview(rowData, 'next-round')
    // this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Data Updated' });
  }

  subAction(rowData) {
    this.interviewData = rowData;
    this.interviewId = rowData.id;
    // this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Data Deleted' });
  }

  constructor(private _router : Router,
   private _viewScheduledInterviewService: ViewScheduledInterviewService,
   private activatedRoute : ActivatedRoute,
   private _handleDataService:HandleDataService,
   private _jobService: JobService,
   private _jobDataService : JobDataService,
   private _applicantService: ApplicantDataService,
    private _interviewStepStatusService: InterviewStepStatusService,
    private _DatePipe: DatePipe,
    private spinner: NgxSpinnerService,
    private messageService: MessageService) {
   }
   scheduleInterview :any={ 
    jobCategory:'',
    technology:'',
    priority:'',
    jobStatus:'',
    jobDescription:'',
    noOfPosition:'',
    createdOn:'',
    openJobCount:'',
    pendingJobCount:'',
    closedJobCount:''
  }
  filter:any={
    interviewStatus:'',
    applicantName:''
  }
  brands: any;
  colors: any;
  interviewCols: any;
  cars:any;
  pageSize: number = 100;
  first: number = 0;
  interviewStepCols:any;
  interviewStatusCols:any;
  applicants:any;
  jobId:any;
  displayFeedbackPopup :any;
  displayCancelPopup:any;
  interviewStepDetails:any;
  interviewstepData : any;
  applicantNames:any;
  interviewData:any;
  allInterviewStatus:any;
  interviewStatusTableData:any;
  interviewStatusTableDataOne :any[]=[];
  interviewStatusTableDataTwo :any[]=[];
  interviewStatusTableDataThree:any[]=[];
  showInterviewTable:boolean=true; 
  interviewStatusIds:any;
  interviewStepStatusIds:any;
  interviewId:any;
  interviewStatusId:any;
  display=false;
  ngOnInit() {
   
    // this.items = [
    //   {
    //     label: 'View All Feedback', icon: 'pi pi-comment', command: () => {
    //       this.update();
    //     }
    //   },
    //   {
    //     label: 'Roll-out Offer', icon: 'pi pi-file', command: () => {
    //       this.delete();
    //     }
    //   },
    //   { label: "Don't Offer", icon: 'pi pi-file', url: 'http://angular.io' },
    //   // { separator: true },
    //   // { label: 'Setup', icon: 'pi pi-cog', routerLink: ['/setup'] }
    // ];
      this.spinner.show();
      this.interviewStatusIds=Messages.interviewStatusIds;
      this.interviewStepStatusIds= Messages.interviewStepStatusIds;
      this.jobId= this.activatedRoute.snapshot.params['id'];
      var clearFilterStatus=localStorage.getItem('clearFilter');
      if(clearFilterStatus!=null && clearFilterStatus=='true'){
        localStorage.removeItem("searchDto");
      }
      var searchDto:any = localStorage.getItem('searchDto')
      searchDto = JSON.parse(searchDto);
      if(history && history.state && history.state.data){
        if(history && history.state && history.state.data && history.state.data.applicantData && history.state.data.applicantData.length>0){
          this.filter.applicantName=history.state.data.applicantData;
          this.jobId=history.state.data.jobId;
          this.filterParam();
        }
      }
      else if(searchDto != null){
        this.filter.applicantName = searchDto.applicant;
        this.filter.interviewStatus = searchDto.status;
        this.jobId=searchDto.jobId;
        this.filterParam();
      }
      else{
      var applicantParams=this.queryParams("applicant.firstName",1);
      this.callInteviewService(applicantParams,true);
      }

      var appParams= this.queryParams("firstName",1);
      this._applicantService.list(appParams,Messages.endpoint.getAllApplicant).subscribe(res => {
        this.applicantNames= res;
      });
      var params= this.queryParams("name",1);
      this._interviewStepStatusService.list(params,'interview-status').subscribe(res => {
        this.allInterviewStatus= res;
        this.joiningStatusOptions = res.filter(word => word["id"] == this.interviewStatusIds.joined || word["id"] == this.interviewStatusIds.didnt_join);
        this.joiningStatusOptions.unshift({
          name: "Select",
          id: null
        });

    });
    this.loadInterviewSchedule();
    this.loadCurrentStatus();
      
      this.interviewCols = [
          { field: 'fullName', header: 'Candidate Name' },
          { field: 'phone', header: 'Mobile' },
          { field: 'email', header: 'Email ID' },
          //{ field: 'scheduledBy', header: 'Scheduled By' },
          { field: 'primaryRecruiter', header: 'Primary Recruiter' },
          { field: 'interviewStatus', header: 'Status' },
          { field: 'actions', header: 'Actions' } 
      ];
      this.interviewStepCols=[
        { field: 'date', header: 'Date & Time' ,},
        { field: 'interviewType', header: 'Interview Type' },
        { field: 'interviewModeData', header: 'Interview Mode' },
        { field: 'interviewer', header: 'Interviewer' },
        { field: 'interviewStatus', header: 'Status' },
        { field: 'actions', header: 'Actions' }
      ];
      this.interviewStatusCols=[
        { field: 'status', header: 'Status' },
        { field: 'count', header: 'counts' },
      ];
  }
  loadCurrentStatus(){
    var params= this.queryParams("name",1);
      this._viewScheduledInterviewService.get(this.jobId,params,'interview/interview-status').subscribe(res => {
        this.interviewStatusTableData=res;
        for(let i=0;i< 4;i++){
          this.interviewStatusTableDataOne[i]=this.interviewStatusTableData[i];
        }
        let j=0;
        for(let i=4,  j=0; i< 8;i++,j++){
        this.interviewStatusTableDataTwo[j]=this.interviewStatusTableData[i];
        }
        for(let i=8,  j=0;i< this.interviewStatusTableData.length;i++,j++){
        this.interviewStatusTableDataThree[j]=this.interviewStatusTableData[i];
        }
      });
  }

  loadInterviewSchedule(){
    this._jobDataService.read(this.jobId).subscribe(
      res => {
          this.scheduleInterview.jobCategory= res.roleName ? res.roleName : '';
          this.scheduleInterview.technology= res.technologyName ? res.technologyName : '';
          this.scheduleInterview.priority= res.jobPriortyName ? res.jobPriortyName : '';
          this.scheduleInterview.jobStatus= res.jobStatusName ? res.jobStatusName : '';
          this.scheduleInterview.jobDescription= res.jobDescriptionName ? res.jobDescriptionName : '';
          this.scheduleInterview.noOfPosition=res.noOfVacancies ? res.noOfVacancies:'';
          this.scheduleInterview.openJobCount=res.openJobCount ? res.openJobCount: 0;
          this.scheduleInterview.closedJobCount=res.closedJobCount? res.closedJobCount : 0;
          this.scheduleInterview.pendingJobCount = res.pendingJobCount ?res.pendingJobCount : 0;
          this.scheduleInterview.createdOn=res.createdOn ? res.createdOn : '';
      });
  }

  interviewStepdetails(interviewId){
    var params= this.queryParams("startTime",-1);
    var endpoint =Messages.endpoint.interview_interviewStepMapping+interviewId;
    this._viewScheduledInterviewService.list(params,endpoint).subscribe(res => {
      
      this.interviewStepDetails=res;

      for(let i=0;i< this.interviewStepDetails.length;i++){

        this.interviewStepDetails[i]['interviewStepDetails']= this.interviewStepDetails[i];
        this.interviewStepDetails[i]['date']=this.interviewStepDetails[i].startDate;
        this.interviewStepDetails[i]['interviewType']=this.interviewStepDetails[i].interviewStep.name;
        this.interviewStepDetails[i]['interviewModeData']=this.interviewStepDetails[i].interviewMode && this.interviewStepDetails[i].interviewMode.name;
        this.interviewStepDetails[i]['interviewerObj']=this.interviewStepDetails[i].interviewer;
        this.interviewStepDetails[i]['interviewer']=this.interviewStepDetails[i].interviewer.map(users => {
                      return users.firstName + ' ' + users.lastName}).join(',');
        this.interviewStepDetails[i]['interviewStatusObj']=this.interviewStepDetails[i].interviewStepStatus;
        this.interviewStepDetails[i]['interviewStatus']=this.interviewStepDetails[i].interviewStepStatus?this.interviewStepDetails[i].submitted==1 || this.interviewStepDetails[i].submitted==-1?this.interviewStepDetails[i].interviewStepStatus.name:'Feedback saved as draft':'';
        this.interviewStepDetails[i]['jobId']=this.jobId;
        this.interviewStepDetails[i]['islast']=i==0?false:true;
        this.interviewStepDetails[i]['submitted']=this.interviewStepDetails[i].submitted;

      }
    });

  }

  callInteviewService(params,onLoad?:any){
    this._viewScheduledInterviewService.get(this.jobId,params,'interview/job').subscribe(res => {
      this.spinner.hide();
    
      this.applicants=res;
      if(this.applicants.length>0){
        for(let i=0;i< this.applicants.length;i++){
          this.applicants[i]['fullName']=this.applicants[i].applicantFullName
          this.applicants[i]['phone']=this.transformPhoneNumber(this.applicants[i].applicant.phone);
          this.applicants[i]['email']=this.applicants[i].applicant.email;
          //this.applicants[i]['scheduledBy']=this.applicants[i].scheduledByName?this.applicants[i].scheduledByName: '';
          this.applicants[i]['primaryRecruiter']=this.applicants[i].primaryRecruiterName?this.applicants[i].primaryRecruiterName: '';
          this.applicants[i]['interviewStatus']=this.applicants[i].candidateStatusName ?this.applicants[i].candidateStatusName: '';
          this.applicants[i]['interviewStatusId']=this.applicants[i].candidateStatusId ?this.applicants[i].candidateStatusId: '';

          let disabledNextRound = this.applicants[i]['interviewStatusId'] == this.interviewStatusIds.scheduled ||
              this.applicants[i]['interviewStatusId'] == this.interviewStatusIds.offered ||
              this.applicants[i]['interviewStatusId'] == this.interviewStatusIds.joined ||
              this.applicants[i]['interviewStatusId'] == this.interviewStatusIds.didnt_join ||
              this.applicants[i]['interviewStatusId'] == this.interviewStatusIds.didnt_offered

          this.applicants[i]['submitted'] =  this.applicants[i]['submitted'] ;
          if (this.applicants[i]['submitted'] == 0) {
            this.applicants[i]['interviewStatus']="Feedback saved as draft"
          }
          this.applicants[i]['items'] =  [];
          if(!disabledNextRound){
            this.applicants[i]['items'].push({
              label: 'View All Feedback', icon: 'pi pi-clock', command: () => {
                this._router.navigateByUrl("/feedback/"+this.interviewId);
              }
            })
          }
          switch (this.applicants[i]['interviewStatusId']) {
            case this.interviewStatusIds.waiting_for_offer:
              this.applicants[i]['items'].push({
                label: 'Roll-out Offer', icon: 'pi pi-file', command: () => {
                  this.dialogHeader = 'Fill Offer Roll-out Details'
                  this.isOffer = true;
                  this.isJoining = false;
                  this.display = true;
                  this.interviewStatusId = this.interviewStatusIds.offered;
                }
                })
                this.applicants[i]['items'].push({ 
                  label: "Don't Offer", icon: 'pi pi-file', command: () => {
                    this.dialogHeader = "Fill Don't Offer Details";
                    this.isOffer = false;
                    this.isJoining = false;
                    this.display = true;
                    this.interviewStatusId = this.interviewStatusIds.didnt_offered;
                  }
                })
                break;
              
            case this.interviewStatusIds.offered:
              this.applicants[i]['items'].push({
                label: 'View All Feedback', icon: 'pi pi-clock', command: () => {
                  this._router.navigateByUrl("/feedback/"+this.interviewId);
                }
              })
              break;

            default:
              break;
          }            
        }
        if(this.applicants[0].searchDto.applicant || this.applicants[0].searchDto.status || this.applicants[0].searchDto.applicant.length>0 || this.applicants[0].searchDto.status.length>0){
            localStorage.setItem('searchDto' , JSON.stringify(this.applicants[0].searchDto));
        }
      }else{
        // onLoad ? this.showInterviewTable=false : '';
        this.showInterviewTable=this.applicants.length>0?true:false;
      }       
    });
  }

  submitForm(data){
    let obj = {}
    //offered
    if(this.isOffer && !this.isJoining){
      obj = {
          "interview": this.interviewId,
          "interviewStatus":this.interviewStatusId ,
          "offerRollOutDate":String(this._DatePipe.transform(data.value.offerDate, 'dd MMM yyyy hh:mm a')),
          "offeredJoiningDate":String(this._DatePipe.transform(data.value.joiningDate, 'dd MMM yyyy hh:mm a')),
          "comments":data.value.comments

        }
      if(new Date(data.value.offerDate)>new Date(data.value.joiningDate)){
        this.validSLA = false;
        return
      }
      data.form.reset()
      this._viewScheduledInterviewService.post(obj,'interview/save/post-interview-data').subscribe(res => {
        let applicantParams=this.queryParams("applicant.firstName",1);
        this.callInteviewService(applicantParams,true);
        this.loadInterviewSchedule();
        this.loadCurrentStatus();
        this.display = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Offer roll-out' });
      })
    }
    //didn't offer
    if(!this.isOffer && !this.isJoining){
      obj = {
        "interview": this.interviewId,
        "interviewStatus":this.interviewStatusId ,
        "offerRollOutDate":String(this._DatePipe.transform(data.value.someDate, 'dd MMM yyyy hh:mm a')),
        "comments":data.value.comments
      }
      data.form.reset()
      this._viewScheduledInterviewService.post(obj,'interview/save/post-interview-data').subscribe(res => {
        let applicantParams=this.queryParams("applicant.firstName",1);
        this.callInteviewService(applicantParams,true);
        this.loadInterviewSchedule();
        this.loadCurrentStatus();
        this.display = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Didnt Offer' });

      })
    }
    //joining
    if(!this.isOffer && this.isJoining){
      obj = {
        "interview": this.interviewId,
        "interviewStatus":data.value.joiningStatus.id ,
        "actualJoiningDate":String(this._DatePipe.transform(data.value.someDate, 'dd MMM yyyy hh:mm a')),
        "comments":data.value.comments
      }
      data.form.reset()
      this._viewScheduledInterviewService.post(obj,'interview/save/post-interview-data').subscribe(res => {
        let applicantParams=this.queryParams("applicant.firstName",1);
        this.callInteviewService(applicantParams,true);
        this.loadInterviewSchedule();
        this.loadCurrentStatus();
        this.display = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Joining Status update' });

      })
    }

  }

  reirectToScheduleInterview(interview,endurl,interviewStep?:any){
    interview = {...interview, ...interviewStep};
    this._handleDataService.setReScheduleInterviewDetails(interview);
    this._router.navigate(['schedule-interview/'+ this.jobId + '/' + endurl])
  }
  filterParam(event?:any){
    var applicantNameArr=[];
    var interviewStatusArr=[];
    var params=null;
    if(this.filter.applicantName ||this.filter.interviewStatus){
      if(this.filter.applicantName && this.filter.applicantName.length>0){
          applicantNameArr=this.returnFilterArray(this.filter.applicantName);
      }
      if(this.filter.interviewStatus && this.filter.interviewStatus.length>0){
          interviewStatusArr=this.returnFilterArray(this.filter.interviewStatus);
      }
        params = this.queryParams(undefined,undefined,applicantNameArr,interviewStatusArr)
      this.callInteviewService(params);
    }else{
      var applicantParams=this.queryParams("applicant.firstName",1);
      this.callInteviewService(applicantParams);
    }
  }
  clearAllFilter(){
    this.showInterviewTable=true;
    this.filter.applicantName='';
    this.filter.interviewStatus=''
    localStorage.removeItem('searchDto');
    this.showInterviewTable=true;
    this.filterParam();
  }
  returnFilterArray(filterArr){
    var filteredArr=[];
    for(var i=0;i<filterArr.length;i++){
      filteredArr.push(filterArr[i].id)
    }
    return filteredArr;
  }
  queryParams(sortFieldName?:string,sortOrder?:any,applicantNameArr?:any,interviewStatusArr?:any){
      const queryParams = new Object();
        // sort order as number, 1 for asc and -1 for dec
      queryParams['sortParam'] = { sortField:sortFieldName , sortOrder: sortOrder };
      queryParams['pageParam'] = {
      page:
          this.first / this.pageSize > 1
          ? this.first / this.pageSize + 1
            : this.first / this.pageSize,
        size: this.pageSize
      };
      queryParams['viewScheduleFilter'] = {'candidate':applicantNameArr,'interviewStatus':interviewStatusArr}
      const dropDownSortingQueryOptions = new QueryOptions(queryParams);
      dropDownSortingQueryOptions.toQueryMap();
      return dropDownSortingQueryOptions;
  }
  showFeedbackPopup = function (bool: boolean, interviewStep :any,rowData:any) {
      setTimeout(() => {
        this._router.navigate([`/candidate-evaluation`], { state: { data: { interviewStepMappingId: interviewStep.id,interviewId:interviewStep.interviewId, feedbackdisabled:!bool,disabledOtherFields:true,jobId:this.jobId} } });
      }, 400)
      //this.interviewstepData=interviewStep;
      //this.displayFeedbackPopup = bool;
      //this.interviewData=rowData
    // this.feedbackpopup.showDialog(true);
  }

  redirectToconfirm(bool: boolean, interviewStep :any){
    this.interviewstepData=interviewStep;
    this.displayCancelPopup = bool;
  }
  showDialog(data){
    data.form.reset();
  }
  transformPhoneNumber(phone:string) {

    const areaCodeStr = phone.slice(0,3);
    const midSectionStr = phone.slice(3,6);
    const lastSectionStr = phone.slice(6);

    return `${areaCodeStr}-${midSectionStr}-${lastSectionStr}`;
  }
  // downloadExcel() {
  // const applicantFilter = this.filter.applicantName ? this.filter.applicantName.join(',') : '';
  // const statusFilter = this.filter.interviewStatus ? this.filter.interviewStatus.join(',') : '';

  // this._viewScheduledInterviewService.exportInterviewExcel(this.jobId, applicantFilter, statusFilter)
  //   .subscribe((blob: Blob) => {
  //     const fileName = 'scheduled_interviews.xlsx';
  //     const link = document.createElement('a');
  //     const url = window.URL.createObjectURL(blob);
  //     link.href = url;
  //     link.download = fileName;
  //     link.click();
  //     window.URL.revokeObjectURL(url);
  //   }, error => {
  //     console.error('Excel export failed', error);
  //     this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to export Excel' });
  //   });
  // }

  downloadExcel() {
  // Prepare filters
  const applicantFilter = this.filter.applicantName ? this.filter.applicantName.join(',') : '';
  const statusFilter = this.filter.interviewStatus ? this.filter.interviewStatus.join(',') : '';

  // Call service to get Excel blob
  this._viewScheduledInterviewService.exportInterviewExcel(this.jobId, applicantFilter, statusFilter)
    .subscribe(
      (blob: Blob) => {
        // Use FileSaver to download safely
        const fileName = 'scheduled_interviews.xlsx';
        saveAs(blob, fileName); 
      },
      (error) => {
        console.error('Excel export failed', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to export Excel' });
      }
    );
}

  downloadPdf() {
  const applicantFilter = this.filter.applicantName ? this.filter.applicantName.join(',') : '';
  const statusFilter = this.filter.interviewStatus ? this.filter.interviewStatus.join(',') : '';

  this._viewScheduledInterviewService.exportInterviewPdf(this.jobId, applicantFilter, statusFilter)
    .subscribe((blob: Blob) => {
      const fileName = 'scheduled_interviews.pdf';
      const link = document.createElement('a');
      const url = window.URL.createObjectURL(blob);
      link.href = url;
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(url);
    }, error => {
      console.error('PDF export failed', error);
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to export PDF' });
    }); 
  }
}

